module.exports = __webpack_public_path__ + "static/img/ent-12.a8f4c87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-12.jpg
// module id = Omov
// module chunks = 51